import BaseApiService from './BaseApiService.js';

class SubUserService extends BaseApiService {
  
  // ---------------- ENTERPRISE IAM APIS ----------------

  // Fetch all staff users
  async getAllStaff() {
    return this.makeRequest('/api/admin/subuser/staff', { method: 'GET' });
  }

  // Get specific staff by ID
  async getStaffById(userId) {
    return this.makeRequest(`/api/admin/subuser/staff/${userId}`, { method: 'GET' });
  }

  // Create new staff
  async createStaff(userData) {
    return this.makeRequest('/api/admin/subuser/staff', {
      method: 'POST',
      body: JSON.stringify(userData)
    });
  }

  // Update staff profile
  async updateStaff(userId, userData) {
    return this.makeRequest(`/api/admin/subuser/staff/${userId}`, {
      method: 'PUT',
      body: JSON.stringify(userData)
    });
  }

  // Delete staff
  async deleteStaff(userId) {
    return this.makeRequest(`/api/admin/subuser/staff/${userId}`, { method: 'DELETE' });
  }

  // Update staff status (ACTIVE, INACTIVE, SUSPENDED, BLOCKED)
  async updateStaffStatus(userId, status) {
    return this.makeRequest(`/api/admin/subuser/staff/${userId}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status })
    });
  }

  // Admin password reset for staff
  async resetStaffPassword(userId, newPassword) {
    return this.makeRequest(`/api/admin/subuser/staff/${userId}/password`, {
      method: 'PATCH',
      body: JSON.stringify({ password: newPassword })
    });
  }

  // Update module permissions
  async updateStaffPermissions(userId, permissions) {
    return this.makeRequest(`/api/admin/subuser/staff/${userId}/permissions`, {
      method: 'PATCH',
      body: JSON.stringify({ modulePermissions: permissions })
    });
  }

  // Fetch staff specific audit logs
  async getStaffAuditLogs(userId) {
    return this.makeRequest(`/api/admin/subuser/staff/audit/${userId}`, { method: 'GET' });
  }

  // Fetch staff login history
  async getStaffLoginHistory(userId) {
    return this.makeRequest(`/api/admin/subuser/staff/login-history/${userId}`, { method: 'GET' });
  }

  // ---------------- LEGACY APIS (For Backwards Compatibility) ----------------

  async getAllSubUsers() {
    return this.getAllStaff();
  }

  async createSubUser(userData) {
    return this.createStaff(userData);
  }

  async updateSubUser(userId, userData) {
    return this.updateStaff(userId, userData);
  }

  async deleteSubUser(userId) {
    return this.deleteStaff(userId);
  }

  async getUserPermissions(userId) {
    return this.makeRequest(`/api/admin/subuser/${userId}/permissions`, { method: 'GET' });
  }

  async updateUserPermissions(userId, permissionsData) {
    return this.makeRequest(`/api/admin/subuser/staff/${userId}/permissions`, {
      method: 'PATCH',
      body: JSON.stringify(permissionsData)
    });
  }

  async getRoleTemplates() {
    return this.makeRequest('/api/admin/subuser/templates', { method: 'GET' });
  }

  async unlockSubUser(userId) {
    return this.updateStaffStatus(userId, 'ACTIVE');
  }

  async getMyPermissions() {
    return this.makeRequest('/api/admin/subuser/my-permissions', { method: 'GET' });
  }

  async getAuditLogs() {
    return this.makeRequest('/api/admin/subuser/audit-logs', { method: 'GET' });
  }

  async getPaymentConfig(orgId) {
    return this.makeRequest(`/api/fees/admin/config/upi/${orgId}`, { method: 'GET' });
  }

  async updatePaymentConfig(configData) {
    return this.makeRequest('/api/fees/admin/config/upi', {
      method: 'POST',
      body: JSON.stringify(configData)
    });
  }
}

const subUserService = new SubUserService();
export default subUserService;
